import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import SearchResultPage from "components/sitelet/search-results-page";
import InputPage from "components/sitelet/input-page";
import IndexLandingPage from "components/sitelet/index-landing-page";
import Explorer from "components/explorer";
import MissingPage from "../missing-page";

function RouteManager({ signedIn }: { signedIn: boolean }) {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<IndexLandingPage />} />
        <Route path="/view/:id" element={<InputPage />} />
        <Route path="/search" element={<SearchResultPage />} />
        <Route path="/explorer" element={<Explorer />} />
        <Route path="*" element={<MissingPage />} />
      </Routes>
    </HashRouter>
  );
}

export default RouteManager;
